import { render, staticRenderFns } from "./waybillDetail.vue?vue&type=template&id=fd18ba04&scoped=true"
import script from "./waybillDetail.vue?vue&type=script&lang=js"
export * from "./waybillDetail.vue?vue&type=script&lang=js"
import style0 from "./waybillDetail.vue?vue&type=style&index=0&id=fd18ba04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd18ba04",
  null
  
)

export default component.exports